import * as RadioGroup from '@radix-ui/react-radio-group'
import * as React from 'react'

import { styled } from '~/styled'
import { Override } from '~/utilities/types'

const StyledRadioButton = styled(
  RadioGroup.Item,
  {
    base: [
      'items-center',
      'appearance-none',
      'bg-transparent',
      'border',
      'border-grey-800',
      'rounded-full',
      'text-white',
      'cursor-pointer',
      'flex',
      'justify-center',
      'p-0',
      'size-4',
      'transition-all',
      'duration-50',
      'ease-out',
      'focus:outline-2',
      'focus:outline-offset-1',
      'focus:outline-primary-800',
      'focus:outline-solid',
      'data-[state=checked]:bg-primary-800',
      'data-[state=checked]:border-primary-800',
      'disabled:bg-grey-200',
      'disabled:border-grey-800',
      'disabled:cursor-not-allowed',
      'disabled:text-grey-800',
      'disabled:data-[state=checked]:bg-grey-800',
      'disabled:data-[state=checked]:border-grey-800'
    ],
    variants: {
      size: {
        md: ['size-4'],
        lg: ['-mt-1', 'size-6']
      }
    }
  },
  { enabledResponsiveVariants: true }
)

const StyledIndicator = styled(
  RadioGroup.Indicator,
  {
    base: ['size-1.5', 'rounded-full', 'bg-current', 'absolute'],
    variants: {
      size: {
        md: ['size-1.5'],
        lg: ['size-3']
      }
    }
  },
  { enabledResponsiveVariants: true }
)

type RadioButtonProps = Override<
  React.ComponentProps<typeof StyledRadioButton>,
  {
    as?: never
  } & {
    'aria-label'?: string
  }
>

export const RadioButton = ({ size, ...props }: RadioButtonProps) => {
  return (
    <StyledRadioButton {...props} size={size}>
      <StyledIndicator size={size} />
    </StyledRadioButton>
  )
}

RadioButton.displayName = 'RadioButton'
